export const close_lg = () => (
  <path
    d="M20 4L4 20M4 4l16 16"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
